module.exports = __webpack_public_path__ + "static/media/bg7.5ed84607.jpg";